import { Component, inject, input, output, model, computed, LOCALE_ID, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Loading } from '../../../../utils/loading/loading';

@Component({
  selector: 'app-filter-product-search',
  imports: [FormsModule, Loading],
  templateUrl: './filter-product-search.html',
  styleUrl: './filter-product-search.scss',
})
export class FilterProductSearch {
  private locale = inject(LOCALE_ID);

  label = input.required<string>();
  placeholder = input<string>('');
  loading = input<boolean>(false);
  error = input<string>('');
  // results = input<{ id: number; titleAr: string; titleEn: string }[]>([]);
  results = input<
    {
      id: number;
      titleAr: string;
      titleEn: string;
      image?: string;
      manufacturerCompanyName?: string;
    }[]
  >([]);
  // selectedItem = signal<{ id: number; titleAr: string; titleEn: string } | null>(null);
  selectedItem = signal<{
  id: number;
  titleAr: string;
  titleEn: string;
  image?: string;
  manufacturerCompanyName?: string;
} | null>(null);
  searchTerm = model.required<string>();
  showDropdown = model.required<boolean>();

  searchChange = output<string>();
  // selectItem = output<{ id: number; titleAr: string; titleEn: string }>();
  selectItem = output<{
  id: number;
  titleAr: string;
  titleEn: string;
  image?: string;
  manufacturerCompanyName?: string;
}>();

  inputFocus = output<void>();

  isArabic = computed(() => this.locale.startsWith('ar'));

  onSearchChange(value: string) {
    this.searchChange.emit(value);
  }

  onSelect(item: { id: number; titleAr: string; titleEn: string }) {
    this.selectedItem.set(item);

    const value = this.isArabic() ? item.titleAr || item.titleEn : item.titleEn;

    this.searchTerm.set(value);

    this.selectItem.emit(item);
    this.showDropdown.set(false);
  }
}
